$(document).ready(function () {
    function addProductDiscovery() {
        $.ajax
            ({
                type: 'post',
                url: '/cart/update.js?updates[' + free_product_variant_id + ']=1&updates[' + second_free_product_variant_id + ']=1',
                dataType: 'json',
                success: function (product) {

                    if ($('.cart__page').length > 0) {
                        location.reload();
                    }
                    else {
                        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                            detail:
                            {
                                product: product
                            }
                        }));
                    }
                },
                error: function (error) {
                    // console.log("Error: "+ error);
                }

            });
    }

    function removeProductDiscovery() {
        // console.log('removeProductDiscovery::: ');
        $.ajax
            ({
                type: 'post',
                url: '/cart/update.js?updates[' + free_product_variant_id + ']=0&updates[' + second_free_product_variant_id + ']=0',
                dataType: 'json',
   
                success: function (product) {

                    if ($('.cart__page').length > 0) {
                        location.reload();
                    }
                    else {
                        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                            detail:
                            {
                                product: product
                            }
                        }));
                    }
                },
                error: function (error) {
                    // console.log("Error: "+ error);
                }

            });
    }

    var total_price = 0;
    function manageDiscoveryGift() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {

                total_price = cart.total_price;

                if (cart.item_count > 0) {
                    // console.log('total_price::: ', total_price);
                    // console.log('gift_threhold_amount::: ', gift_threhold_amount);
                    if (total_price > gift_threhold_amount) {
                        for (let id = 0; id < cart.items.length; id++) {
                            const cart_item = cart.items[id];
                            if (cart_item.variant_id == free_product_variant_id || cart_item.variant_id == second_free_product_variant_id) {
                                return false;
                            }
                        }
                        
                        if (free_product_variant_id != '' || second_free_product_variant_id != '') {
                            addProductDiscovery();
                        }
                    }
                    else {
                        if (free_product_variant_id != '' || second_free_product_variant_id != '') {
                            removeProductDiscovery();
                        }
                    }
                }
            })
            .catch(error => {
                // console.error('Error:', error);
            });
    }





    // Target element to observe
    if ($('.cart__page').length > 0) {
        var cartItems = document.querySelector('.custom-subtotal [data-subtotal]');
    }
    else {
        var cartItems = document.querySelector('[data-subtotal]');
    }


    // Function to handle mutations (e.g., node additions)
    let timeout;
    const handleMutations = mutationsList => {
        clearTimeout(timeout);
        mutationsList.forEach(mutation => {
            // console.log('mutation.type::: ', mutation.type);
            if (mutation.type === 'childList') {
                // Nodes have been added to [data-products]

                manageDiscoveryGift();
            }
        });
    };

    // Create a MutationObserver instance
    const observer = new MutationObserver(handleMutations);

    // Configuration of the observer (we want to observe childList mutations)
    const config = { childList: true };

    // Start observing the target node for specified mutations
    observer.observe(cartItems, config);
    if ($('.cart__page').length > 0) {
        manageDiscoveryGift();
    }

});